module.exports = __webpack_public_path__ + "05_medium_brown.e0df1c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_medium_brown.png
// module id = MdHh
// module chunks = 0